export const template6PlaceholderData = {
  id: 1,
  name: 'Menu 1',
  categories: [
    {
      id: 1,
      name: 'Pizza',
      items: [
        {
          id: 1,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 2,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          outOfStock: true,
        },
        {
          id: 3,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
          outOfStock: true,
        },
      ],
    },
    {
      id: 2,
      name: 'Burger',
      items: [
        {
          id: 4,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
          outOfStock: true,
        },
        {
          id: 5,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 6,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
        },
      ],
    },
    {
      id: 3,
      name: 'Drinks',
      items: [
        {
          id: 7,
          itemName: 'Veggie Quesadilla Con Todo And Cheese',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 8,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 9,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 10,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 11,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 12,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
        {
          id: 13,
          itemName: 'Margherita Pizza',
          itemDescription: 'Fresh mozzarella, basil, and a tangy tomato sauce on a crisp thin crust.',
          itemPrice: '4.49',
          modifiers: {},
        },
      ],
    },
  ],
};
